import { CIcon } from '~/icons/types'
export const ciSavedSearch: CIcon = {
  name: 'saved-search',
  type: 'solid',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'm19.033 13.265-.076-.07a1.834 1.834 0 0 1-.078-.073l-.724-.723a6.33 6.33 0 0 1-6.672-10.133 49.422 49.422 0 0 0-5.163.312 2.928 2.928 0 0 0-2.57 2.93V21a.75.75 0 0 0 1.085.67L12 18.09l7.165 3.582A.75.75 0 0 0 20.25 21v-7.107a2.976 2.976 0 0 1-1.144-.568l-.073-.061Z'
    },
    {
      d:
        'm21.775 10.37-.068-.076-1.686-1.686a4.308 4.308 0 0 0 .563-3.098c-.017-.088-.048-.172-.07-.26a4.368 4.368 0 0 0-.159-.51c-.039-.1-.087-.19-.132-.283a4.374 4.374 0 0 0-.229-.421 4.629 4.629 0 0 0-.506-.657c-.052-.054-.1-.11-.155-.162A4.192 4.192 0 0 0 19 2.94c-.109-.086-.216-.174-.333-.25a4.105 4.105 0 0 0-.37-.2 4.15 4.15 0 0 0-.374-.18 4.182 4.182 0 0 0-.513-.158c-.084-.022-.164-.051-.25-.068a4.347 4.347 0 0 0-5.067 3.376 4.36 4.36 0 0 0-.082.65c0 .074-.006.148-.006.223a4.318 4.318 0 0 0 1.577 3.344 4.33 4.33 0 0 0 5.03.344l1.686 1.686.076.068a1 1 0 0 0 1.406-1.406h-.005Zm-3.792-2.386a2.331 2.331 0 1 1-3.294-3.3 2.331 2.331 0 0 1 3.294 3.3Z'
    }
  ]
}
